import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import getMAC, { isMAC } from 'getmac'
import { environment} from '../../environments/environment';
//import {environment} from '../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private BASE_URL: string = environment.API_URL;
   //private BASE_URL: string = "http://52.66.143.47:8000/";
  //private BASE_URL: string = "http://3.108.44.158:8000/uat/";
  //private BASE_URL: string = "http://13.127.121.254:8000/qa/";
  private errorData: any = {};
  //errorData: {};
  userData = "";
  constructor(private http: HttpClient, private router: Router) { }

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };
  user_login(loginForm: any,IP:any) {
   // console.log("IP : " + this.getIPAddress());
    return this.http.post<any>(`${this.BASE_URL}user/login`, {
      "email": loginForm.email, "password": loginForm.password, "session_start_dttm": '', 
      "ip_address": IP, "mac_address": '', "browser": this.myBrowser(), "is_active": '1', "user_type": 1
    })
      .pipe(map(user => {
        if (user) {
          return user;
        }
      }),
        catchError(this.handleError)
      );
  }
  /****create password */
  createPassword(userId: any, password: any) {
    return this.http.post<any>(`${this.BASE_URL}update/user-password`, { "user_id": userId, "password": password })
      .pipe(map(user => {
        if (user) {
          return user;
        }
      }),
        catchError(this.handleError)
      );
  }
  /****change password */
  /*********check password */
  checkPassword(userId:any){
    return this.http.post<any>(`${this.BASE_URL}user/can_createpassornot`, { "user_id": userId })
    .pipe(map(user => {
      if (user) {
        return user;
      }
    }),
      catchError(this.handleError)
    );
  }

   /*********check password */
  changePassword(formData:any) {
    return this.http.post<any>(`${this.BASE_URL}user/change-password`, formData)
      .pipe(map(user => {
        if (user) {
          return user;
        }
      }),
        catchError(this.handleError)
      );
  }
  /****forgot password */
  forgetPassword(formData: any) {
    return this.http.post<any>(`${this.BASE_URL}user/forget-password`, formData)
      .pipe(map(user => {
        if (user) {
          return user;
        }
      }),
        catchError(this.handleError)
      );
  }
  
  admin_login(loginForm: any) {
    console.log(loginForm);
    return this.http.post<any>(`${this.BASE_URL}user/backend/admin/login`, { "email": loginForm.email, "password": loginForm.password, user_type: '2' })
      .pipe(map(user => {
        if (user) {
          return user;
        }
      }),
        catchError(this.handleError)
      );
  }

  isLoggedIn() {
    if (localStorage.getItem('userData')) {
      return true;
    }
    return false;
  }
  /***get IP address */
  getIPAddress() {
    this.http.get("https://jsonip.com/").subscribe((res: any) => { return res.ip;
    },(error) => {  console.log(error); });
  }

  myBrowser() {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      return 'Opera';
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return 'Chrome';
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return 'Safari';
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return 'Firefox';
    } else if ((navigator.userAgent.indexOf("MSIE") != -1)) { //|| (!!document.documentMode == true )
      return 'IE';
    } else {
      return 'unknown';
    }
  }

  /*getAuthorizationToken() {
    const userData = JSON.parse(localStorage.getItem('userData'));
    return userData.token;
  }*/

  logout() {
    localStorage.removeItem('userData');
  }
  // Userlogout() {
  //   localStorage.removeItem('userLoginData');
  // }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {

      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {

      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }

    // return an observable with a user-facing error message
    this.errorData = {
      errorTitle: 'Oops! Request for document failed',
      errorDesc: 'Something bad happened. Please try again later.'
    };
    return throwError(this.errorData);
  }
  //Courses 
  assigned_courses() {
    return this.http.post<any>(`${this.BASE_URL}user/courses/`, '')
      .pipe(map(userCourses => {
        if (userCourses) {
          return userCourses;
        }
      }),
        catchError(this.handleError)
      );
  }
}
